import m from "../../geodata/es2015/venezuelaHigh";
window.am4geodata_venezuelaHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/venezuelaHigh.js
// module id = null
// module chunks = 